import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { Outlet as a, useMatch as d, Link as c } from "react-router";
import { cn as n, buttonVariants as h, CardHeader as u, CardTitle as m } from "@workspace/shadcn";
import { ArrowRight as k } from "lucide-react";
function s({
  className: t,
  ...o
}) {
  const i = (/* @__PURE__ */ new Date()).getFullYear();
  return /* @__PURE__ */ r("p", { className: n("w-full border-t py-4 text-center", t), ...o, children: [
    "All rights reserved to Al Takassusi General Limited Company (ITGL) ©",
    " ",
    i
  ] });
}
function l(t) {
  return /* @__PURE__ */ e(
    "img",
    {
      src: "/images/logo-lockup.webp",
      alt: "Al Takassusi General Limited Company",
      ...t
    }
  );
}
function f({ items: t }) {
  return /* @__PURE__ */ r("div", { className: "bg-primary mt-auto flex h-full w-36 flex-col items-center rounded-lg pt-12 text-sm", children: [
    /* @__PURE__ */ e(l, { src: "/images/logo-mark.webp", className: "mb-11 h-24 w-24" }),
    /* @__PURE__ */ e("div", { className: "w-full space-y-4 px-1", children: t.map((o) => /* @__PURE__ */ r(p, { to: o.href, children: [
      o.icon,
      /* @__PURE__ */ e("span", { children: o.label })
    ] }, o.href)) })
  ] });
}
function p({ to: t, children: o }) {
  const i = d(t);
  return /* @__PURE__ */ e(
    c,
    {
      to: t,
      className: h({
        variant: "ghost",
        className: n(
          "text-primary-foreground hover:text-primary-foreground flex h-auto w-full flex-col items-center py-4 hover:bg-black/20",
          i ? "bg-black/20" : ""
        )
      }),
      children: o
    }
  );
}
function v({
  children: t,
  items: o
}) {
  return /* @__PURE__ */ e("div", { className: "flex h-full min-h-0 flex-col md:p-4 md:pb-4", children: /* @__PURE__ */ r("div", { className: "flex h-full min-h-0 flex-1 flex-col", children: [
    /* @__PURE__ */ r("div", { className: "flex h-full min-h-0 w-full", children: [
      /* @__PURE__ */ e(f, { items: o }),
      /* @__PURE__ */ r("div", { className: "mx-8 flex min-h-0 w-full flex-1 flex-col gap-4", children: [
        t,
        /* @__PURE__ */ e(a, {})
      ] })
    ] }),
    /* @__PURE__ */ e(s, { className: "mt-8 pb-0" })
  ] }) });
}
function N(t) {
  return /* @__PURE__ */ r("div", { className: "flex h-full flex-col bg-white", children: [
    /* @__PURE__ */ e("div", { className: "grid h-full grid-cols-1 overflow-auto p-0 sm:p-8", children: /* @__PURE__ */ e(
      "div",
      {
        className: n(
          "flex h-full w-full items-center justify-center rounded-none sm:rounded-xl",
          t.center && "px-0 sm:px-60",
          t.className
        ),
        children: /* @__PURE__ */ r("div", { className: "w-full max-w-[460px] px-4 sm:px-4 lg:px-0", children: [
          /* @__PURE__ */ r(u, { className: n("mt-4 space-y-4 px-0"), children: [
            /* @__PURE__ */ e(l, { className: "mx-auto mb-4 w-40" }),
            /* @__PURE__ */ r("div", { className: "space-y-2", children: [
              /* @__PURE__ */ r("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ e(m, { className: "text-2xl font-bold", children: t.title }),
                t.onBack && /* @__PURE__ */ r(
                  "button",
                  {
                    type: "button",
                    onClick: t.onBack,
                    className: "flex cursor-pointer items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-900",
                    children: [
                      /* @__PURE__ */ e(k, { className: "size-4" }),
                      t.backLabel ?? "رجوع"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ e("div", { className: "font-medium", children: t.subtitle })
            ] })
          ] }),
          /* @__PURE__ */ e("div", { className: "mt-6", children: t.children })
        ] })
      }
    ) }),
    /* @__PURE__ */ e(s, {})
  ] });
}
function b() {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: 28,
      height: 29,
      viewBox: "0 0 28 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M22.1667 4.84155H5.83333C4.54467 4.84155 3.5 5.88622 3.5 7.17489V23.5082C3.5 24.7969 4.54467 25.8416 5.83333 25.8416H22.1667C23.4553 25.8416 24.5 24.7969 24.5 23.5082V7.17489C24.5 5.88622 23.4553 4.84155 22.1667 4.84155Z",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M18.6666 2.50806V7.17472",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M3.5 11.8416H24.5",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M9.33337 2.50806V7.17472",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M19.8334 16.5081H12.8334",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M15.1666 21.1748H8.16663",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M8.16663 16.5081H8.17788",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M19.8334 21.1748H19.8446",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function y() {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: 28,
      height: 29,
      viewBox: "0 0 28 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M14 2.50806C16.2635 2.50764 18.4782 3.16568 20.3743 4.40197C22.2703 5.63826 23.7658 7.39941 24.6785 9.47077C25.5911 11.5421 25.8815 13.8342 25.5142 16.0677C25.1469 18.3012 24.1379 20.3797 22.61 22.0497",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M14 7.1748V14.1748L18.6667 16.5081",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M2.91671 10.5291C2.54495 11.6592 2.34823 12.8395 2.33337 14.0291",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M3.30176 18.8416C3.95684 20.3487 4.92294 21.7004 6.13676 22.8082",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M5.40869 6.2823C5.73424 5.92791 6.0814 5.59399 6.44819 5.28247",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M10.0847 25.1648C12.994 26.2012 16.1956 26.0418 18.9876 24.7214",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
export {
  N as AuthLayout,
  b as CalendarIcon,
  y as ClockHistoryIcon,
  s as Footer,
  v as Layout,
  l as Logo
};
//# sourceMappingURL=index.js.map
